export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8325 0.349816C18.2696 1.80669 21.4962 7.39537 20.0394 12.8325C19.6736 14.1977 19.0473 15.4235 18.2283 16.4708L24 22.2422L22.2422 24L16.4693 18.2269C14.0345 20.126 10.7691 20.9001 7.55669 20.0394C2.11957 18.5825 -1.10706 12.9938 0.349816 7.55669C1.80669 2.11957 7.39537 -1.10706 12.8325 0.349816ZM2.75098 8.20008C1.64944 12.3111 4.08909 16.5367 8.20008 17.6382C12.3111 18.7397 16.5367 16.3001 17.6382 12.1891C18.7397 8.07811 16.3001 3.85252 12.1891 2.75098C8.07811 1.64944 3.85252 4.08909 2.75098 8.20008Z"
      fill="currentColor"
    />
  </svg>
);
